import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Prevent scroll wheel from changing focused number input values (#2527)
document.addEventListener(
    'wheel',
    () => {
        if (document.activeElement?.type === 'number') {
            document.activeElement.blur();
        }
    },
    { passive: true }
);
